import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

    ProgramsEmpty:{
        k: "programs.empty.title",
        v: "No Programs Found"
    },
    ProgramNotfoundDescription:{
        k: "programs.empty.description",
        v: ""
    },
    ViewDetails:{
        k:"program.view",
        v:"View Details"
    }
});


// WEBPACK FOOTER //
// ./src/panels/programs/Programs.labels.ts